mutation ArchiveAutomations($ids: [ID!]!) {
  archiveAutomations(ids: $ids) {
    id
  }
}
